import { Box } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';
import { DownloadAppModal } from '../../common';
import { CHAT_WITH_US_INSURANCE } from '../../../constants';

const InsuranceHeroButtons: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <Box
      flexDir={{ base: 'column', tablet: 'row' }}
      justifyContent={{ base: 'center', desktop: 'flex-start' }}
      mb={{ base: 700, desktop: 0 }}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Button
        colorScheme="primary"
        variant="solid"
        mb={{ base: 400, desktop: 0 }}
        w={{ base: '100%', tablet: 'auto' }}
        onClick={toggleModal}
      >
        GET STARTED
      </Button>
      <ArrowButton
        onClick={() => navigate(CHAT_WITH_US_INSURANCE)}
        mb={{ base: 600, desktop: 0 }}
        variant="minimal"
        w={{ base: '100%', tablet: 'auto' }}
      >
        Chat with us
      </ArrowButton>
    </Box>
  );
};

export default InsuranceHeroButtons;
